var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-list" },
    [
      _vm.loading
        ? _vm._l(1, function (n) {
            return _c(
              "div",
              { key: n, staticClass: "content-list-items" },
              [_vm._t("default", null, { item: {} })],
              2
            )
          })
        : _vm.items.length > 0
        ? _vm._l(_vm.items, function (item) {
            return _c(
              "div",
              { key: item.id, staticClass: "content-list-items" },
              [_vm._t("default", null, { item: item })],
              2
            )
          })
        : _c("div", [_vm._v("\n    No items found.\n  ")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }